import styled from "@emotion/styled";
import * as React from "react";

import { IInvoice } from "interfaces/entities/invoice";
import { contentPaddingSmallValue } from "routes/styled";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-named-as-default
import EditInvoiceEmail from "../components/EditInvoiceEmail";

import SubscriptionInvoicesEmptyState from "./SubscriptionInvoicesEmptyState";
import { SubscriptionInvoicesTable } from "./SubscriptionInvoicesTable";

export const SubscriptionInvoicesList: React.FC<IProps> = ({ invoiceEmail, invoices, hasSubscription }) => (
  <StyledWrapper>
    {invoices?.length ? (
      <>
        <InvoiceEmailWrapper>
          <EditInvoiceEmail email={invoiceEmail} />
        </InvoiceEmailWrapper>
        <SubscriptionInvoicesTable invoices={invoices} />
      </>
    ) : (
      <SubscriptionInvoicesEmptyState hasSubscription={hasSubscription} />
    )}
  </StyledWrapper>
);

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

interface IProps {
  invoiceEmail: string | null;
  invoices: IInvoice[];
  hasSubscription: boolean;
}

const InvoiceEmailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 40px;
  margin-bottom: ${contentPaddingSmallValue}px;
`;
